@switch (activeMultiPlanFeatureFlag) {
  @case (multiPlanProtectionDetailsVariants.Test) {
    <app-grid-container class="plan-sale">
      <app-grid-row class="white-container-alt">
        <app-grid-column>
          <app-grid-row>
            <app-grid-column>
              <app-progression-steps />
              <app-badge-text
                [color]="'pink'"
                [text]="'APPLIANCE COVER BUNDLE - NO FIXED TERM CONTRACT'"
                class="plan-sale-alt__badge"
              />
            </app-grid-column>
          </app-grid-row>
          <app-grid-row class="plan-sale-alt__description-container">
            <app-grid-column [md]="6">
              <h1 class="plan-sale-alt__description-header">
                {{ "PLAN_SALE_ALT_DESCRIPTION_HEADER" | translate }}
              </h1>
              <p class="plan-sale-alt__description-body">
                Help avoid expensive repairs or the cost of a replacement with
                <b>immediate accidental damage cover</b> for your new appliance.
                Plus get
                <b>unlimited breakdown and accidental damage cover</b> for your
                older appliances.
              </p>
            </app-grid-column>

            <app-grid-column [md]="6">
              <app-panel
                [class.plan-sale-alt__inclusion-panel-expanded]="
                  inclusionExpanded
                "
                class="plan-sale-alt__inclusion-panel"
              >
                <div class="plan-sale-alt__inclusion-panel-header">
                  <h3 class="plan-sale-alt__inclusion-panel-title">
                    {{ "PLAN_SALE_ALT_INCLUSION_PANEL_TITLE" | translate }}
                  </h3>
                  <button
                    (click)="toggleInclusionExpanded()"
                    class="plan-sale-alt__inclusion-panel-button"
                    type="button"
                  >
                    <app-icon
                      [name]="'chevron-down'"
                      class="plan-sale-alt__inclusion-panel-chevron"
                    />
                  </button>
                </div>
                <div class="plan-sale-alt__inclusion-panel-dropdown">
                  <p class="plan-sale-alt__provided-by">
                    {{ "PLAN_SALE_PAGE_PROVIDED_BY" | translate }}
                    <img
                      [src]="`assets/dg.svg`"
                      alt="DNG Logo"
                      class="plan-sale-alt__provided-by-logo"
                    />
                  </p>
                  <ul class="plan-sale-alt__benefits">
                    @for (benefit of benefitsAlt; track $index) {
                      <li class="plan-sale-alt__benefit">{{ benefit }}</li>
                    }
                  </ul>
                </div>
              </app-panel>
            </app-grid-column>
          </app-grid-row>
          @if (localeIdIsGB()) {
            <div class="plan-sale-alt__trustpilot-panel">
              <p class="plan-sale-alt__trustpilot-hint">
                {{ "PLAN_SALE_ALT_TRUSTPILOT_HINT" | translate }}
              </p>
              <div class="plan-sale-alt__trustpilot-container">
                <app-trustbox />
              </div>
            </div>
          }

          <div class="plan-sale-alt__bundle-panel">
            <h2 class="plan-sale-alt__bundle-panel-title">
              {{
                "PLAN_SALE_ALT_BUNDLE_PANEL_TITLE"
                  | translate
                    : {
                        applianceName:
                          vm.basketItemApplianceDetails.applianceName,
                      }
              }}
            </h2>
            <div class="plan-sale-alt__bundle-panel-registered">
              <div>
                <h3 class="plan-sale-alt__bundle-panel-registered-heading">
                  {{ clientName }}
                  {{ vm.basketItemApplianceDetails.applianceName }}
                </h3>
                <p class="plan-sale-alt__bundle-panel-registered-subheading">
                  {{
                    "PLAN_SALE_ALT_BUNDLE_PANEL_REGISTERED_SUBHEADING"
                      | translate
                  }}
                </p>
              </div>
              <p
                class="plan-sale-alt__single-appliance-card__price-value-neutral"
              >
                {{
                  "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE_SLASH"
                    | translate
                      : {
                          price: singleAppliancePrice | currencyFormat: "1.0-2",
                        }
                }}
              </p>
            </div>
            <h2 class="plan-sale-alt__bundle-panel-subtitle">
              {{
                "PLAN_SALE_ALT_BUNDLE_PANEL_SUBTITLE"
                  | translate
                    : {
                        additionalPrice:
                          additionalAppliancePrice() | currencyFormat: "1.0-2",
                      }
              }}
            </h2>
            <div class="plan-sale-alt__bundle-panel-appliances">
              @for (appliance of appliances(); track $index) {
                <app-labelled-checkbox
                  (changed)="
                    onApplianceSelectedChange(appliance.applianceName, $event)
                  "
                  [checked]="appliance.isSelected"
                  [disabled]="
                    (selectedAppliances().length >= 7 &&
                      !appliance.isSelected) ||
                    formSubmitted
                  "
                  [label]="appliance.applianceName"
                />
              }
            </div>
            @if (showSelectedAppliancesDisclaimer()) {
              <p
                class="plan-sale-alt__multi-appliance-card-appliances-disclaimer"
              >
                {{
                  "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_APPLIANCES_DISCLAIMER"
                    | translate
                }}
              </p>
            }

            <div class="plan-sale-alt__bundle-panel-appliances-summary">
              <div class="plan-sale-alt__bundle-panel-appliance-badge">
                <p class="plan-sale-alt__bundle-panel-appliance-badge-text">
                  {{
                    `${selectedAppliances().length + 1} appliance${selectedAppliances().length > 0 ? "s" : ""}`
                  }}
                </p>
              </div>
              <p class="plan-sale-alt__single-appliance-card__price-value">
                {{
                  "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE_SLASH"
                    | translate
                      : {
                          price: total() | currencyFormat: "1.0-2",
                        }
                }}
              </p>
            </div>
            <p class="plan-sale-alt__cancel-anytime">
              {{ "PLAN_SALE_PAGE_CANCEL_ANYTIME" | translate }}
            </p>
          </div>

          <app-grid-row class="plan-sale-alt__footer-buttons--desktop">
            <app-grid-column [md]="6">
              <app-button
                (click)="registerOnlyClicked()"
                [fill]="true"
                [variant]="'primary-alternative'"
              >
                {{ "PLAN_SALE_REGISTER_ONLY" | translate }}
              </app-button>
            </app-grid-column>
            <app-grid-column [md]="6">
              <app-button
                (click)="
                  selectedAppliances().length < 1
                    ? singleAppliancePlanClicked()
                    : multiAppliancePlanClicked()
                "
                [fill]="true"
                [loading]="formSubmitted"
                [variant]="'primary'"
              >
                {{
                  `Continue (${selectedAppliances().length + 1} appliance${selectedAppliances().length > 0 ? "s" : ""})`
                }}
              </app-button>
            </app-grid-column>
          </app-grid-row>
          <app-grid-row class="plan-sale-alt__footer-buttons--mobile">
            <app-grid-column [md]="6">
              <app-button
                (click)="
                  selectedAppliances().length < 1
                    ? singleAppliancePlanClicked()
                    : multiAppliancePlanClicked()
                "
                [fill]="true"
                [loading]="formSubmitted"
                [variant]="'primary'"
              >
                {{
                  `Continue (${selectedAppliances().length + 1} appliance${selectedAppliances().length > 0 ? "s" : ""})`
                }}
              </app-button>
            </app-grid-column>
            <app-grid-column [md]="6">
              <app-button
                (click)="registerOnlyClicked()"
                [fill]="true"
                [variant]="'primary-alternative'"
                class="plan-sale-alt__footer-button--bottom"
              >
                {{ "PLAN_SALE_REGISTER_ONLY" | translate }}
              </app-button>
            </app-grid-column>
          </app-grid-row>
        </app-grid-column>
      </app-grid-row>
    </app-grid-container>
  }
  @default {
    <app-grid-container class="plan-sale">
      <app-grid-row class="white-container">
        <app-grid-column>
          <app-grid-row>
            <app-grid-column>
              <app-progression-steps />

              <div class="plan-sale__header">
                @if (lowRiskPurchasePrice) {
                  <app-grid-row class="plan-sale__header-bundle-appliances">
                    <app-grid-column [block]="'md'" [hidden]="'xs'" [md]="4" />
                    <app-grid-column
                      [sm]="4"
                      [xs]="6"
                      class="plan-sale__header-bundle-appliances-column-two"
                    >
                      <img
                        [src]="`assets/appliances.svg`"
                        alt="Appliances"
                        class="plan-sale__appliance-image"
                      />
                    </app-grid-column>
                    <app-grid-column
                      [md]="4"
                      [xs]="6"
                      class="plan-sale__header-bundle-appliances-column-three"
                    >
                      <app-badge-text
                        [deal]="true"
                        [text]="'Exclusive Bundle Offer'"
                        class="plan-sale__header-deal-badge"
                      />
                    </app-grid-column>
                  </app-grid-row>

                  <app-grid-row>
                    <app-grid-column>
                      <app-badge-text
                        [text]="'PLAN_SALE_PAGE_HEADER_BADGE' | translate"
                        class="plan-sale__header-badge"
                      />
                    </app-grid-column>
                  </app-grid-row>
                } @else {
                  <img [src]="`assets/appliances.svg`" alt="Appliances" />
                }

                <h1 class="plan-sale__header-title">
                  {{ "PLAN_SALE_PAGE_TITLE" | translate }}
                </h1>
                @if (lowRiskPurchasePrice) {
                  <h2 class="plan-sale__header-subtitle">
                    {{ "PLAN_SALE_PAGE_SUBTITLE" | translate }}
                  </h2>
                }
              </div>

              <app-panel
                [panelSpacing]="'lg'"
                class="plan-sale__benefits-panel"
              >
                <h3 class="plan-sale__benefits-panel-header">
                  What's included
                </h3>
                <div class="plan-sale__benefits">
                  @for (benefit of benefits; track $index) {
                    <app-benefit
                      class="plan-sale__benefit"
                      description="{{ benefit.description }}"
                      icon="{{ benefit.iconName }}"
                      title="{{ benefit.text }}"
                    />
                  }
                </div>

                @if (localeIdIsGB()) {
                  <div class="plan-sale__benefits-panel-footer">
                    <app-trustbox class="plan-sale__trustpilot" />
                  </div>
                }

                <p class="plan-sale__provided-by">
                  {{ "PLAN_SALE_PAGE_PROVIDED_BY" | translate }}
                  <img
                    [src]="`assets/dg.svg`"
                    alt="DNG Logo"
                    class="plan-plan-sale__provided-by-logo"
                  />
                </p>
              </app-panel>
            </app-grid-column>
          </app-grid-row>

          <p class="plan-sale__choose-cover-or-continue-registering-title">
            {{
              "PLAN_SALE_PAGE_CHOOSE_COVER_OR_CONTINUE_REGISTERING_TITLE"
                | translate
            }}
          </p>

          <app-grid-row>
            <app-grid-column
              [md]="6"
              class="plan-sale__multi-appliance-card-column"
            >
              <app-card class="plan-sale__multi-appliance-card">
                <div class="plan-sale__multi-appliance-card-header">
                  <h3 class="plan-sale__multi-appliance-card-header-title">
                    {{
                      "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_TITLE" | translate
                    }}
                  </h3>

                  @if (lowRiskPurchasePrice) {
                    <app-badge-text
                      [color]="'pink'"
                      [text]="'Exclusive Bundle Offer'"
                      class="plan-sale__multi-appliance-card-header-badge"
                    />
                  }

                  <p class="plan-sale__multi-appliance-card-header-description">
                    {{
                      "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_DESCRIPTION"
                        | translate
                          : {
                              applianceName:
                                vm.basketItemApplianceDetails.applianceName.toLowerCase(),
                            }
                    }}
                    @if (lowRiskPurchasePrice) {
                      Protect as a bundle, save more.
                    }
                  </p>

                  <p class="plan-sale__multi-appliance-card-header-price">
                    {{
                      "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_PRICE"
                        | translate
                          : { price: priceStartingFrom() | currencyFormat }
                    }}
                  </p>
                </div>

                <p class="plan-sale__cancel-anytime">
                  {{ "PLAN_SALE_PAGE_CANCEL_ANYTIME" | translate }}
                </p>

                <div class="plan-sale__multi-appliance-card-logos">
                  <app-partner-logo-grid [columns]="4" />
                </div>

                @if (!buildYourBundleOpened()) {
                  <div class="plan-sale__multi-appliance-card-bundle-button">
                    <app-button
                      (click)="buildYourBundleClicked()"
                      [fill]="true"
                      class="plan-sale__multi-appliance-card-bundle-button-text"
                    >
                      {{
                        "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE"
                          | translate
                      }}
                    </app-button>

                    @if (lowRiskPurchasePrice) {
                      <p
                        class="plan-sale__multi-appliance-card-bundle-button-disclaimer"
                      >
                        {{
                          "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_PREFIX"
                            | translate
                        }}
                        <app-link
                          [navigationLink]="{
                            label: `domesticandgeneral.com`,
                            href: `https://www.domesticandgeneral.com/`,
                          }"
                          [newWindow]="true"
                          class="link--regular"
                        />.
                        {{
                          "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_BUILD_YOUR_BUNDLE_DISCLAIMER_SUFFIX"
                            | translate
                        }}
                      </p>
                    }
                  </div>
                } @else {
                  <div
                    class="plan-sale__multi-appliance-card-registered-appliance"
                  >
                    <div
                      class="plan-sale__multi-appliance-card-registered-appliance-panel"
                    >
                      <h4
                        class="plan-sale__multi-appliance-card-registered-appliance-panel-title"
                      >
                        {{
                          "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_TITLE"
                            | translate
                        }}
                      </h4>
                      <app-labelled-checkbox
                        [checked]="true"
                        [disabled]="true"
                        [label]="
                          `${initialApplianceBrand} ${initialAppliance()?.applianceName}`
                        "
                      />
                    </div>
                    <p
                      class="plan-sale__multi-appliance-card-registered-appliance-text"
                    >
                      {{
                        "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_REGISTERED_APPLIANCE_DISCLAIMER"
                          | translate
                      }}
                    </p>
                  </div>

                  <hr class="plan-sale__multi-appliance-card-separator" />

                  <div
                    class="plan-sale__multi-appliance-card-select-appliances"
                  >
                    <h4
                      class="plan-sale__multi-appliance-card-select-appliances-title"
                    >
                      {{
                        "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_SELECT_APPLIANCES"
                          | translate
                      }}
                    </h4>
                    <div
                      class="plan-sale__multi-appliance-card-select-appliances-list"
                    >
                      @for (appliance of appliances(); track $index) {
                        <app-labelled-checkbox
                          (changed)="
                            onApplianceSelectedChange(
                              appliance.applianceName,
                              $event
                            )
                          "
                          [checked]="appliance.isSelected"
                          [disabled]="
                            selectedAppliances().length >= 7 &&
                            !appliance.isSelected
                          "
                          [label]="appliance.applianceName"
                        />
                      }
                      @if (showSelectedAppliancesDisclaimer()) {
                        <p
                          class="plan-sale__multi-appliance-card-appliances-disclaimer"
                        >
                          {{
                            "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_APPLIANCES_DISCLAIMER"
                              | translate
                          }}
                        </p>
                      }
                    </div>
                  </div>

                  <app-panel
                    class="plan-sale__multi-appliance-card-select-appliances-panel-total"
                  >
                    <h4
                      class="plan-sale__multi-appliance-card-select-appliances-panel-total-value"
                    >
                      {{
                        `${selectedAppliances().length + 1} appliance(s) ${(total() | currencyFormat)} a month`
                      }}
                    </h4>

                    <app-button
                      (click)="multiAppliancePlanClicked()"
                      [disabled]="selectedAppliances().length < 1"
                      [fill]="true"
                      [loading]="formSubmitted"
                    >
                      <p
                        class="plan-sale__multi-appliance-card-bundle-button-text"
                      >
                        {{
                          "PLAN_SALE_PAGE_MULTI_APPLIANCE_CARD_CTA_CONTINUE"
                            | translate
                        }}
                      </p>
                    </app-button>
                  </app-panel>
                }
              </app-card>
            </app-grid-column>

            <app-grid-column
              [md]="6"
              class="plan-sale__single-appliance-card-column"
            >
              <p class="plan-sale__or">or</p>

              <app-card class="plan-sale__single-appliance-card">
                <p class="plan-sale__single-appliance-card__title">
                  {{
                    "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_TITLE"
                      | translate
                        : {
                            applianceName:
                              vm.basketItemApplianceDetails.applianceName,
                          }
                  }}
                </p>

                <p class="plan-sale__single-appliance-card__subtitle">
                  {{
                    "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_SUBTITLE" | translate
                  }}
                </p>

                <p class="plan-sale__single-appliance-card__price-prefix">
                  {{
                    "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_PREFIX"
                      | translate
                  }}
                </p>

                <p class="plan-sale__single-appliance-card__price-value">
                  {{
                    "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_PRICE_VALUE"
                      | translate
                        : {
                            price:
                              singleAppliancePrice | currencyFormat: "1.0-2",
                          }
                  }}
                </p>

                <p class="plan-sale__cancel-anytime">
                  {{ "PLAN_SALE_PAGE_CANCEL_ANYTIME" | translate }}
                </p>

                <app-button
                  (click)="singleAppliancePlanClicked()"
                  [fill]="true"
                  [variant]="'primary-alternative'"
                >
                  {{ "PLAN_SALE_PAGE_SINGLE_APPLIANCE_CARD_CTA" | translate }}
                </app-button>
              </app-card>
            </app-grid-column>
          </app-grid-row>

          <app-grid-row>
            <app-grid-column>
              <div class="plan-sale__register-only">
                <app-button
                  (click)="registerOnlyClicked()"
                  [fill]="true"
                  [variant]="'primary-alternative'"
                >
                  {{ "PLAN_SALE_REGISTER_ONLY" | translate }}
                </app-button>
              </div>
            </app-grid-column>
          </app-grid-row>
        </app-grid-column>
      </app-grid-row>
    </app-grid-container>
  }
}
